import { Space, Typography } from 'antd'
import { FC } from 'react'

interface SavedOrderNumbersProps {
    formNum: string // номер сборки YY-set-order
    extendedNum: string // то же + дизайнер + дата — «номер на формы»
}

const SavedOrderNumbers: FC<SavedOrderNumbersProps> = ({ formNum, extendedNum }) => {
    return (
        <Space direction={'vertical'} size={4}>
            <Space size={8}>
                <Typography.Text type={'secondary'}>Номер сборки:</Typography.Text>
                <Typography.Text
                    copyable={{
                        text: formNum,
                        tooltips: ['Копировать', 'Скопировано'],
                    }}
                >
                    {formNum}
                </Typography.Text>
            </Space>
            <Space size={8}>
                <Typography.Text type={'secondary'}>Номер на формы:</Typography.Text>
                <Typography.Text
                    copyable={{
                        text: extendedNum,
                        tooltips: ['Копировать', 'Скопировано'],
                    }}
                >
                    {extendedNum}
                </Typography.Text>
            </Space>
        </Space>
    )
}

export default SavedOrderNumbers
